
import { mapMutations } from "vuex";
import { getOldStocks } from "~/model/stocks";
import GLOBAL from "../../constants/global";

export default {
  name: "InspirePage",
  head() {
    return {
      titleTemplate: "%s: The secret to high returns with short-term investing",
      title: `${GLOBAL.company}`,
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Position yourself for financial success and achieve a lucrative 7% gain in your investment portfolio in less than a week",
        },
      ],
    };
  },
  data() {
    return {
      items: [],
      page: 1, // Initial page
      pageSize: 4, // Number of items per page
      loading: false,
      reachedEnd: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapMutations({
      SET_MSGS: "ui/SET_MSGS",
    }),
    async fetchData() {
      if (this.loading || this.reachedEnd) return;
      this.loading = true;

      // Replace this with your API endpoint
      const { error, data } = await getOldStocks({
        page: this.page,
        pageSize: this.pageSize,
      });

      if (error) {
        this.loading = false;
        //   console.log("hiii");
        // console.log(error);
        this.SET_MSGS({
          title: "Internal Server Error (500)",
          description:
            "Server has encountered an unexpected condition or configuration problem ",
          color: "var(--v-error-base)",
          icon: "line-md:emoji-frown",
          position: "bottom-left",
        });
      } else {
        if (data.data.length === 0) {
          this.reachedEnd = true;
        } else {
          this.items = [...this.items, ...data.data];
          this.page++;
        }
        this.loading = false;
      }
    },
    handleIntersection(entries) {
      if (entries[0].isIntersecting) {
        // The element is in view, trigger fetchData
        this.fetchData();
      }
    },
  },
};
